




















import { computed, defineComponent } from '@vue/composition-api';

import getProducts from '@/gql/product/getProducts.gql';

const CommonProductSelector = defineComponent({
  props: {
    label: {
      type: String,
      default() { return 'เลือกสินค้า'; },
    },
    value: {},
    level: {},
    showLabel: { default: false },
    rules: { default: '' },
    multiple: { default: false },
    optionLabel: {},
    placeholder: {},
  },
  setup(props: any) {
    const _value = computed(() => props.value);
    return {
      _value,

      getProducts,
      result: (data: any) => data.products.data,
    };
  },
});

export default CommonProductSelector;
